<script>
  import FileDrop from "./FileDrop.svelte";
  import MediaReorder from "./MediaReorder.svelte";

  export let listingId, listingMedias
</script>

<MediaReorder listingId={listingId} bind:items={listingMedias}/>

<FileDrop multiple="multiple" accept="image/*" uploadParam="listing_medias[]" uploadEndpoint="/listings/{listingId}/listing_medias" bind:allFiles={listingMedias}/>

